import { Theater } from 'lucide-react';
import React from 'react';
import { useTheme } from '../../../redux/hooks/useTheme';
import { useNavigate, useLocation } from 'react-router-dom';
interface PlanPopupProps {
    message: string;
    onClose: () => void;
}
function PlanPopup({ message, onClose }: PlanPopupProps) {
const navigate=useNavigate();
    const location = useLocation();
    const { theme } = useTheme();
    const [part1, part2, part3] = message.split('|');
    
    return (
        <div className="fixed inset-0 flex justify-center items-center bg-black bg-opacity-50 z-[99] bilderIndexSub">
            <div style={{backgroundColor:theme.loginPopupbg}} className="bg-white p-6 rounded-lg shadow-lg text-center  w-[582px]">
            <div style={{background:theme.iconbgg}} className="w-14 h-14 bg-[#FFE9EC] rounded-lg flex items-center justify-center mx-auto">
            <span className="text-3xl text-[#FF4D6A]">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M17 18.43H13L8.54999 21.39C7.88999 21.83 7 21.36 7 20.56V18.43C4 18.43 2 16.43 2 13.43V7.42993C2 4.42993 4 2.42993 7 2.42993H17C20 2.42993 22 4.42993 22 7.42993V13.43C22 16.43 20 18.43 17 18.43Z" stroke="url(#paint0_linear_658_32055)" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M12.0001 11.3599V11.1499C12.0001 10.4699 12.4201 10.1099 12.8401 9.81989C13.2501 9.53989 13.66 9.1799 13.66 8.5199C13.66 7.5999 12.9201 6.85986 12.0001 6.85986C11.0801 6.85986 10.3401 7.5999 10.3401 8.5199" stroke="url(#paint1_linear_658_32055)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M11.9955 13.75H12.0045" stroke="url(#paint2_linear_658_32055)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                <defs>
                <linearGradient id="paint0_linear_658_32055" x1="12.7742" y1="17.6622" x2="19.7661" y2="17.6622" gradientUnits="userSpaceOnUse">
                <stop stopColor="#FB5F65"/>
                <stop offset="1" stopColor="#F378C9"/>
                </linearGradient>
                <linearGradient id="paint1_linear_658_32055" x1="12.1286" y1="10.4432" x2="13.2892" y2="10.4432" gradientUnits="userSpaceOnUse">
                <stop stopColor="#FB5F65"/>
                <stop offset="1" stopColor="#F378C9"/>
                </linearGradient>
                <linearGradient id="paint2_linear_658_32055" x1="12.0387" y1="14.0463" x2="12.3883" y2="14.0463" gradientUnits="userSpaceOnUse">
                <stop stopColor="#FB5F65"/>
                <stop offset="1" stopColor="#F378C9"/>
                </linearGradient>
                </defs>
                </svg>

            </span>
          </div>
               <div style={{display:'flex', justifyContent:'center',textAlign:'center', paddingTop:'20px'}}>
               {/* <p style={{color:theme.loginPopupHeading, }} className="text-lg w-[400px] font-semibold">
                    <span style={{fontSize:'24px', fontWeight:700,lineHeight:'30px'}}>This </span>
                    <span style={{fontSize:'24px', fontWeight:700, lineHeight:'30px'}} className="gradient-text-requirement fontSize:'24px', fontWeight:700">feature is not included</span> <span style={{fontSize:'24px', fontWeight:700,lineHeight:'30px'}}>in your current plan.</span>
                </p> */}
                <p style={{ color: theme.loginPopupHeading }} className="text-lg w-[400px] font-semibold">
            <span className='font-inter' style={{ fontSize: '24px', fontWeight: 700, lineHeight: '30px' }}>{part1} </span>
            <span
              style={{ fontSize: '24px', fontWeight: 700, lineHeight: '30px' }}
              className="gradient-text font-inter"
            >
              {part2}
            </span>
            <span className='font-inter' style={{ fontSize: '24px', fontWeight: 700, lineHeight: '30px' }}>{part3}</span>
          </p>
               </div>
                {/* <p style={{fontSize:'18px', fontWeight:400,color:theme.loginPopupHeading}} className="mt-[12px]">
                    Plans managed by <span className="font-semibold"> <span>
                    <span className="inline-block">
                    <img src="https://dlvkyia8i4zmz.cloudfront.net/MIq2hUoySz2yU10fkMGY_Vector__26_.svg" 
                        alt="icon" className="w-5 h-5 inline" />
                    </span>
                    </span > <span  style={{fontSize:'18px', fontWeight:400,color:theme.loginPopupHeading}}>Autoolic</span></span>
                </p> */}
                <div className="flex justify-center mt-4 space-x-[16px]">
                    <button
onClick={onClose}
                        className="px-8 py-3 rounded-[8px] border go-live  transition-colors duration-200 font-medium text-sm"
                    >
                        <span style={{fontSize:'14px',fontWeight:500}} className='gradient-text'> OK</span>
                    </button>
                    <button
onClick={()=>{
    if (location.pathname === '/planinfo') {
        onClose();
    } else {
        navigate('/planinfo');
    }
}}
                        className="px-[20px] py-[9px] rounded-[8px] text-white hover:opacity-90 transition-all duration-200 font-medium text-sm"
                        style={{
                            background: 'linear-gradient(277.16deg, #FB5F65 -22.31%, #FF3AB6 112.77%)',
                        }}
                        >
                       <span style={{fontSize:'14px',fontWeight:500}}> View Plan</span>
                    </button>
                </div>
            </div>

           
        </div>
    );
}

export default PlanPopup;
